import { takeEvery, select, delay, put, cancel, takeLatest } from 'redux-saga/effects';
import { setTimelineDate } from "../timeline/actions";


function* runPlayback(action) {
    const { direction } = action;
    const interval = 100;
    
    yield delay(interval);
    
    const { time, speedPlayback } = yield select(state => state.timeline);
    
    const newTime = Math.min(Date.now(), time + direction * speedPlayback * interval);
    yield put(setTimelineDate(newTime));
}

function* stopAndReinitPlayback(task) {
    yield cancel(task);

    const newTask = yield takeLatest('runPlayback', runPlayback);
    yield takeLatest('setBookmarkCheckedPane', stopAndReinitPlayback, newTask);
}

export default function* () {
    const task = yield takeLatest('runPlayback', runPlayback);
    yield takeLatest('setBookmarkCheckedPane', stopAndReinitPlayback, task);
}